import { get } from 'lodash-es';

export function getEditorialRatingParams(editorialRating, { isScorecardV4, ratingVersion } = {}) {
  if (isScorecardV4) {
    switch (ratingVersion) {
      case '4.1':
        switch (true) {
          case editorialRating < 5.05:
            return { text: 'Poor', badgeClassName: 'poor', bgColorClassName: 'bg-red-100' };
          case editorialRating >= 5.05 && editorialRating < 5.65:
            return { text: 'Below Average', badgeClassName: 'below-avg', bgColorClassName: 'bg-orange-100' };
          case editorialRating >= 5.65 && editorialRating < 6.25:
            return { text: 'Average', badgeClassName: 'avg', bgColorClassName: 'bg-yellow-100' };
          case editorialRating >= 6.25 && editorialRating < 7.05:
            return { text: 'Good', badgeClassName: 'good', bgColorClassName: 'bg-green-100' };
          case editorialRating >= 7.05 && editorialRating < 7.8:
            return { text: 'Very Good', badgeClassName: 'very-good', bgColorClassName: 'bg-green-100' };
          default:
            return { text: 'Excellent', badgeClassName: 'excellent', bgColorClassName: 'bg-green-100' };
        }
      default:
        switch (true) {
          case editorialRating < 6:
            return { text: 'Poor', badgeClassName: 'poor', bgColorClassName: 'bg-red-100' };
          case editorialRating >= 6 && editorialRating < 6.5:
            return { text: 'Below Average', badgeClassName: 'below-avg', bgColorClassName: 'bg-orange-100' };
          case editorialRating >= 6.5 && editorialRating < 7.6:
            return { text: 'Average', badgeClassName: 'avg', bgColorClassName: 'bg-yellow-100' };
          case editorialRating >= 7.6 && editorialRating < 8.1:
            return { text: 'Good', badgeClassName: 'good', bgColorClassName: 'bg-green-100' };
          case editorialRating >= 8.1 && editorialRating < 8.4:
            return { text: 'Very Good', badgeClassName: 'very-good', bgColorClassName: 'bg-green-100' };
          default:
            return { text: 'Excellent', badgeClassName: 'excellent', bgColorClassName: 'bg-green-100' };
        }
    }
  }

  switch (true) {
    case editorialRating <= 7.1:
      return { text: 'Below Average', badgeClassName: 'below-avg', bgColorClassName: 'bg-orange-100' };
    case editorialRating <= 7.6:
      return { text: 'Average', badgeClassName: 'avg', bgColorClassName: 'bg-purple-100' };
    case editorialRating <= 8:
      return { text: 'Good', bgColorClassName: 'bg-turquoise-100' };
    default:
      return { text: 'Great', badgeClassName: 'great', bgColorClassName: 'bg-green-100' };
  }
}

export function getCurrentStyleId({ styles, sharedTrimName }) {
  return (
    (styles &&
      get(
        styles.find(({ trim }) => trim === sharedTrimName),
        'id'
      )) ||
    get(styles, '[0].id')
  );
}
